import {main_phaser} from "../framework/src/engine/madnes/MadnesApp";
import {madnes_anim_add, madnes_anim_loop, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";
import {
    madnes_get_alpha,
    madnes_get_pos_y,
    madnes_get_scale_y,
    madnes_get_texture,
    madnes_set_alpha, madnes_set_pos,
    madnes_set_pos_y,
    madnes_set_scale,
    madnes_set_texture, madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {
    fps,
    he,
    he_scale,
    ico_he,
    mega_win,
    multi, states,
    super_win, wi,
    wi_scale
} from "../framework/src/engine/madnes/madnes_variables";
import {
    bet,
    coin_val,
    lines_count,
    madnes_eval, madnes_is_mega_win,
    madnes_is_super_mega_win,
    madnes_money_to_coin,
    win
} from "../framework/src/engine/madnes/madnes";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {
    madnes_alpha_to,
    madnes_move_to,
    madnes_rotate_to,
    madnes_scale_to
} from "../framework/src/engine/madnes/madnes_render";
import {set_blink_state} from "./joker27plus_reels";
import {joker27plus_fs_gb_cont, joker27plus_money_add_control, set_win_anim_played, win_type} from "./joker27plus_core";
import {
    madnes_audio_fade_out,
    madnes_audio_is_playing,
    madnes_audio_play
} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {cylinder_pos, icons} from "./joker27plus_config";
import {joker27plus_print_reels} from "./joker27plus_core_printer";
import {STATES} from "../framework/src/states/states";

var joker27plus_fs_vibrate_enabled = false;
function joker27plus_fs_vibrate_start()
{
    joker27plus_fs_vibrate_enabled = true;
    joker27plus_fs_vibrate_control();
}

export function joker27plus_fs_vibrate_end()
{
    joker27plus_fs_vibrate_enabled = false;
}

function joker27plus_fs_vibrate_control()
{
    var max_dif_x = 16;
    var max_dif_Y = 0;
    var max_time = ( 1000 / fps ) * 0.6;

    if(joker27plus_fs_vibrate_enabled)
    {

        var nx = Math.round( ( Math.random() * max_dif_x ) - ( max_dif_x / 2 ) );
        var ny = Math.round( ( Math.random() * max_dif_Y ) - ( max_dif_Y / 2 ) );
        madnes_move_to("fs_center", nx, ny, max_time, joker27plus_fs_vibrate_control);
        madnes_move_to("fs_center0", nx, ny, max_time);
    }
    else
    {
        madnes_move_to("fs_center", 0, 0, max_time);
        madnes_move_to("fs_center0", 0, 0, max_time);
    }

}


var joker27plus_windesk_pos = 0;

var joker27plus_windesk_active = false;
var joker27plus_windesk_fst = false;

export function joker27plus_windesk_show()
{
    states.setState(STATES.BONUS_WIN);

    //alert("Big win " + ( ( ( win * coin_val ) / 100 ) * lines_count ) );

    set_blink_state("moneyadd"); //blink_state = "moneyadd";

    madnes_anim_loop("flares_sprite", "anim");
    madnes_set_pos_y("flares_sprite", he / 2);
    madnes_set_alpha("flares_sprite", 0);


    joker27plus_windesk_active = true;
    joker27plus_windesk_fst = true;
    joker27plus_windesk_blink();

    if(win_type == 'fs')
    {
        madnes_set_texture("bigwins_text", "free_spins_win");
    }
    else
    {
        if(madnes_is_super_mega_win(win, bet))
        {
            madnes_set_texture("bigwins_text", "super_mega_win");
        }
        else if(madnes_is_mega_win(win, bet))
        {
            madnes_set_texture("bigwins_text", "mega_win");
        }
        else
        {
            madnes_set_texture("bigwins_text", "big_win");
        }
    }

    madnes_set_scale("bigwins_text", 2, 2);

    madnes_set_text("bigwins_sum", madnes_money_to_coin(win));

    set_win_anim_played(true); //win_anim_played = true;

    madnes_set_pos_y("bigwins", he * 0.5);
    madnes_set_scale("bigwins", 0.2, 0.2);
    madnes_set_alpha("bigwins", 0);
    madnes_set_pos_y("bigwins_text", -400);

    setTimeout(function()
    {

        if(win_type == 'fs')
        {
            setTimeout(function(){
                madnes_audio_play("bwin_FreeSpins");
            }, 100);
        }
        else
        {
            setTimeout(function(){
                madnes_audio_play("bwin_big_win");
            }, 100);
        }



        madnes_alpha_to("flares_sprite", 1, 200);
        madnes_alpha_to("bigwins", 1, 160);
        madnes_tween_to("bigwins", {
                x:1,
                y:1
            },
            {
                duration: 500,
                scale: true,
                callback: joker27plus_windesk_show2,
                easing: "back_out",
            }
        );
    }, 400);

    //joker27plus_windesk_hide();
}

function joker27plus_windesk_show2()
{
    madnes_set_visible("bigwins_text", true);

    madnes_tween_to("bigwins_text", {
            x:0,
            y:0
        },
        {
            duration: 600,
            easing: "bounce_out",
        }
    );

    madnes_tween_to("bigwins", {
            x:1.1,
            y:1.1
        },
        {
            duration: 600,
            scale: true,
            callback: joker27plus_windesk_show3,
            easing: "back_out",
        }
    );
}

function joker27plus_windesk_show3()
{
    var eas = "back_out";
    var time = 600;
    if(win_type == 'fs' || 1)
    {
        eas = "linear";
        time = 400;
    }

    madnes_tween_to("bigwins", {
            x:1,
            y:1
        },
        {
            duration: time,
            scale: true,
            callback: joker27plus_windesk_show4,
            easing: eas,
        }
    );
}

function joker27plus_windesk_show4()
{
    var time = 400;
    if(win_type == 'fs' || 1)
    {
        if(joker27plus_windesk_pos++ < 2)
        {
            madnes_tween_to("bigwins", {
                    x:1.05,
                    y:1.05
                },
                {
                    duration: 400,
                    scale: true,
                    callback: function(){
                        madnes_tween_to("bigwins", {
                                x:1,
                                y:1
                            },
                            {
                                duration: 400,
                                scale: true,
                                callback: joker27plus_windesk_show4,
                                //easing: "back_out",
                            }
                        );
                    },

                }
            );
            return;
        }
        else
        {
            time = 1;
        }
    }

    setTimeout(function()
    {

        setTimeout(madnes_alpha_to.bind(this, "bigwins", 0, 200), 100);

        madnes_alpha_to("flares_sprite", 0, 200);

        madnes_tween_to("bigwins", {
                x:1.8,
                y:1.8
            },
            {
                duration: 300,
                scale: true,
                callback: joker27plus_windesk_show5,
                easing: "back_in",
            }
        );

    }, time);
}

function joker27plus_windesk_show5(freespinsData)
{
    madnes_set_pos_y("bigwins", -9999);
    madnes_set_pos_y("flares_sprite", -9999);
    madnes_anim_play("flares_sprite", "stop");

    joker27plus_windesk_active = false;
    joker27plus_windesk_hide(freespinsData);
}

function joker27plus_windesk_hide()
{
    joker27plus_windesk_pos = 0;
    joker27plus_money_add_control(1);
}

function joker27plus_windesk_blink()
{
    if(joker27plus_windesk_active)
    {
        var time = 100;
        if(joker27plus_windesk_fst)
        {
            joker27plus_windesk_fst = false;
            time = 0;
        }

        if(madnes_get_alpha("bigwins_lights_0") == 0)
        {
            setTimeout(function() {
                madnes_alpha_to("bigwins_lights_0", 0.8, 250, joker27plus_windesk_blink);
                madnes_alpha_to("bigwins_lights_1",   0, 250, joker27plus_windesk_blink);
            }, time);
        }
        else
        {
            setTimeout(function() {
                madnes_alpha_to("bigwins_lights_0",   0, 250, joker27plus_windesk_blink);
                madnes_alpha_to("bigwins_lights_1", 0.8, 250, joker27plus_windesk_blink);
            }, time);
        }
    }
    else
    {
        madnes_alpha_to("bigwins_lights_0", 0, 250);
        madnes_alpha_to("bigwins_lights_1", 0, 250);
    }
}

// Freespin -> zobrazeni / skryti ohoreleho valce konec

// animace cislic pri vyhre

var tmp = {
    'win': 9876,
    'line': 1,
    'position': new Array(
        Array(0,0),
        Array(1,0),
        Array(2,0),
        Array(3,0),
        Array(0,1),
        Array(1,1),
        Array(2,1),
        Array(3,1),
        Array(0,2),
        Array(1,2),
        Array(2,2),
        Array(3,2)
    )
}

var pk_lock_1 = 1;

var win_sum_groups = new Array();
var win_sum_buffer = new Array();
var win_sum_buffer_pos = 0;

function joker27plus_show_win_sum_start(win_set)
{
    /*
    console.log(win_set);

    for(var i in win_set.position)
    {
        var x = win_set.position[i][0]
        var y = win_set.position[i][1]
        var sum = win_set.win.toString();

        if(!madnes_key_exist("joker27plus_show_win_sum_" + x))
        {
            madnes_add_bitmap_text("joker27plus_show_win_sum_" + x, "wintable", cylinder_pos[x], he * 0.2 + y * 200, sum, 80);
            madnes_set_img_center("joker27plus_show_win_sum_" + x, 0.5, 0.5);
        }
        else
        {
            madnes_set_text("joker27plus_show_win_sum_" + x, sum);
            madnes_set_pos_y("joker27plus_show_win_sum_" + x, he * 0.2 + y * 200);
        }

    }
    */

    if(pk_lock_1 == 1)
    {
        pk_lock_1 = 0;
    }
    else
    {
        return;
    }

    var money = win_set.win.toString();
    var money2 = "";
    var pos_pom = 0;
    /*
    for(var i = money.length - 1; i >=0; i--)
    {
        money2 = money.substr(i, 1) + money2;
        pos_pom++;
        if(pos_pom % 3 == 0 && i != 0)
        {
            money2 = " " + money2;
        }
    }

    money = money2;
    console.log(money);
    */

    var digits = money.toString().length;
    var line = win_set.line * 1 + 1 * 1;
    var count = win_set.position.length;

    var center = cylinder_pos[2];
    if(count <= 3)
    {
        center = cylinder_pos[1];
    }

    center = center * 1 + 100;

    var top = 0;

    for(var i0 = 0; i0 < win_set.position.length; i0++)
    {
        var x = win_set.position[i0][0];
        var y = win_set.position[i0][1];

        top = 65 + ico_he * y;

        center = cylinder_pos[x];
        if(digits < 5)
        {
            center = center * 1 + 110;
        }
        else
        {
            center = center * 1 + 114;
        }

        var cur_pos = win_sum_buffer_pos;
        win_sum_buffer_pos = win_sum_buffer_pos * 1 + 1;

        if(win_sum_buffer_pos >= 12)
        {
            win_sum_buffer_pos = 0;
        }

        //console.log(win_sum_buffer_pos);

        win_sum_groups[cur_pos] = main_phaser.add.group();
        win_sum_buffer[cur_pos] = new Array();
        for(var i = 0; i < digits; i++)
        {
            var num_wi = 60;
            if(digits > 3)
            {
                num_wi = 40;
            }

            var left = center * 1 - ( num_wi / 2 * digits ) + num_wi * i + Math.floor( ( digits - i - 1) / 3) * num_wi * -0.5;
            win_sum_buffer[cur_pos][i] = main_phaser.add.sprite(left * wi_scale, top * he_scale, 'font_big-win_Small');
            win_sum_groups[cur_pos].add(win_sum_buffer[cur_pos][i]);

            for(var j = 0; j <= 10; j++)
            {
                win_sum_buffer[cur_pos][i].animations.add(j.toString(), [j]);
            }
            win_sum_buffer[cur_pos][i].animations.play(money.substr(i,1).toString().replace(" ", "10"), 20, false);

            if(digits <= 3)
            {
                win_sum_buffer[cur_pos][i].scale.setTo(wi_scale * multi * 0.8, he_scale * multi * 0.8);
            }
            else
            {
                win_sum_buffer[cur_pos][i].scale.setTo(wi_scale * multi * 0.6, he_scale * multi * 0.6);
            }



            win_sum_buffer[cur_pos][i].alpha = 0;
        }

        joker27plus_show_win_sum_anim(cur_pos, 0);
    }
}

function joker27plus_show_win_sum_anim(pos, alpha)
{
    alpha = alpha * 1 + ( 1 / 4 );
    alpha = Math.round(alpha * 100) / 100;
    var alpha2 = alpha;
    if(alpha2 >= 2.8)
    {
        alpha2 = 1-(alpha2-2.8);
    }
    if(alpha2 > 1)
    {
        alpha2 = 1;
    }
    if(alpha2 < 0)
    {
        alpha2 = 0;
    }
    for(var i = 0; i < win_sum_buffer[pos].length; i++)
    {
        win_sum_buffer[pos][i].alpha = alpha2;
        win_sum_buffer[pos][i].y = win_sum_buffer[pos][i].y*1-(4*he_scale);
    }

    if(alpha <= 4)
    {
        setTimeout("joker27plus_show_win_sum_anim("+pos+", "+alpha+")", 1000 / fps);
    }
    else
    {
        for(var i = 0; i < win_sum_buffer[pos].length; i++)
        {
            win_sum_buffer[pos][i].x = -9999;
            win_sum_buffer[pos][i].y = -9999;
            win_sum_buffer[pos][i] = null;
        }
        win_sum_buffer[pos] = null;
        win_sum_groups[pos].removeAll(true,false);
        win_sum_groups[pos] = null;
        if(pk_lock_1 == 0)
        {
            pk_lock_1 = 1;
        }
    }
}

var joker27plus_fullplate_callback = null;
export function joker27plus_fullplate_start(callback)
{
    joker27plus_fullplate_callback = callback;

    for(var i = 0; i < 3; i++)
    {
        for(var j = 0; j < 3; j++)
        {
            var txt = madnes_get_texture("reels_bufer_" + i + "_S" + j).replace(/_blur/, "");

            madnes_set_texture("reels_bufer_" + i + "_TMP" + j , txt);
            madnes_set_scale("reels_bufer_" + i + "_TMP" + j, 1, madnes_get_scale_y("reels_bufer_" + j + "_S" + j ) );
            for(var anim in icons[txt])
            {
                madnes_anim_add("reels_bufer_" + i + "_TMP" + j, anim, icons[txt][anim]);
            }

            if(madnes_get_pos_y("reels_bufer_" + i + "_S" + j) > 0)
            {
                madnes_set_pos_y(
                    "reels_bufer_" + i + "_TMP" + j,
                    madnes_get_pos_y("reels_bufer_" + i + "_S" + j)
                );

                madnes_set_pos_y(
                    "reels_bufer_" + i + "_S" + j,
                    -9999
                );
            }

            if(madnes_get_alpha("dark_cover") == 0)
            {
                madnes_alpha_to("dark_cover", 1, 200);
            }
        }
    }

    for(var i = 0; i < 3; i++)
    {
        for(var j = 0; j < 3; j++)
        {
            madnes_anim_play("reels_bufer_" + i + "_TMP" + j, "anim", 45);
        }
    }


    setTimeout(function() {
        madnes_audio_play("win_multiplier");
    }, 100)


    madnes_set_pos("full_screen", -100, he * 0.5);
    //madnes_move_to("full_screen", wi * 0.5, he * 0.5, 600);

    //madnes_set_pos("full_screen", wi * 0.5, he * -1 * 0.4);
    //madnes_set_scale("full_screen_x2", 0.8, 0.8);

    madnes_rotate_to("full_screen", 360 * 2, 1, 550);

    madnes_set_alpha("full_screen", 0);
    madnes_alpha_to("full_screen", 1, 550);

    madnes_tween_to("full_screen", {
            x: wi * 0.5,
            y: he * 0.5
        },
        {
            duration: 550,
            //easing: "back_out",
            callback: joker27plus_fullplate_1
        }
    );

}

function joker27plus_fullplate_1()
{
    joker27plus_fullplate_blink_en = true;
    joker27plus_fullplate_blink();

    madnes_tween_to("full_screen_x2", {
            x: 1.3,
            y: 1.3
        },
        {
            duration: 300,
            //easing: "bounce_in_out",
            easing: "back_in_out",
            scale: true,
            callback: joker27plus_fullplate_2
        }
    );
}

function joker27plus_fullplate_2()
{
    madnes_tween_to("full_screen_x2", {
            x: 0.8,
            y: 0.8
        },
        {
            duration: 500,
            //easing: "bounce_in_out",
            easing: "back_in_out",
            scale: true,
            callback: joker27plus_fullplate_3
        }
    );
}

function joker27plus_fullplate_3()
{
    joker27plus_fullplate_blink_en = false;

    madnes_tween_to("full_screen", {
            x: wi * 0.5,
            y: he * 1.5
        },
        {
            duration: 400,
            delay: 200,
            easing: "back_in",
            callback: joker27plus_fullplate_callback
        }
    );
}

var joker27plus_fullplate_blink_en = false;
function joker27plus_fullplate_blink()
{
    if(joker27plus_fullplate_blink_en)
    {
        if(madnes_get_alpha("full_screen_light") == 0)
        {
            madnes_alpha_to("full_screen_light", 1, 160, joker27plus_fullplate_blink);
        }
        else
        {
            madnes_alpha_to("full_screen_light", 0, 160, joker27plus_fullplate_blink);
        }
    }
    else
    {
        madnes_alpha_to("full_screen_light", 0, 160);
    }
}


var joker27plus_fs_start_anim_callback = null;
var joker27plus_fs_start_anim_dir = 0;
var joker27plus_fs_start_anim_cnt = 0;
export function joker27plus_fs_start_anim(count, callback)
{
    joker27plus_print_reels();
    joker27plus_fs_vibrate_start();

    //madnes_audio_play("bonus_FreeSpins_Prepare");
    madnes_audio_play("bonus_FreeSpins_Start");

    // ADD
    if(madnes_audio_is_playing("bg_main"))
    {
        madnes_audio_fade_out("bg_main", 400);
        madnes_audio_play("bg_free_spins_start");
        setTimeout(joker27plus_fs_gb_cont, 2400);
    }
    // ADD end


    joker27plus_fs_start_anim_dir = 0;
    joker27plus_fs_start_anim_cnt = 0;

    joker27plus_fs_start_anim_callback = callback;
    madnes_set_text("fs_entry_num", count.toString());
    madnes_set_pos("fs_entry_group", wi * 0.5, he * 0.5);
    madnes_set_alpha("fs_entry_group", 0);
    madnes_set_scale("fs_entry_group", 0, 0);

    madnes_rotate_to("fs_entry_bg", 360 * 1.1, 1, 3000);
    madnes_alpha_to("fs_entry_group", 1, 200);
    madnes_scale_to("fs_entry_group", 1.04, 1.04, 300, joker27plus_fs_start_anim2);
}

function joker27plus_fs_start_anim2()
{
    if(joker27plus_fs_start_anim_dir++ % 2 == 0)
    {
        if(joker27plus_fs_start_anim_cnt++ < 5)
        {
            madnes_scale_to("fs_entry_group", 1, 1, 140, joker27plus_fs_start_anim2);
        }
        else
        {
            madnes_scale_to("fs_entry_group", 0, 0, 300, joker27plus_fs_start_anim3);
            setTimeout(function() {
                madnes_alpha_to("fs_entry_group", 0, 200);
            }, 100);
        }
    }
    else
    {
        madnes_scale_to("fs_entry_group", 1.03, 1.03, 140, joker27plus_fs_start_anim2);
    }
}

function joker27plus_fs_start_anim3()
{
    if(typeof joker27plus_fs_start_anim_callback != "undefined" && joker27plus_fs_start_anim_callback != null)
    {
        madnes_eval(joker27plus_fs_start_anim_callback);
    }
}
